import track from '~helpers/track'
import Wrap from '~utils/Wrap'

/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

const scrollCheck = (location) =>
  [
    '/community/tutorials/', // Algolia search
    '/docs/api-reference/overview/', // Swagger docs with their weird DOM choices 🤷‍♂️
    '/resources/', // Algolia search
    '/product/', // Tab switching; we take care of this on the page
    '/blog/', // Algolia search
    '/press/media/', // Algolia search
  ].includes(location.pathname)

// gatsby-browser.js
export const shouldUpdateScroll = ({
  routerProps: { location },
  getSavedScrollPosition,
}) => {
  const currentPosition = getSavedScrollPosition(location)

  // Don't update scroll position on certain pages since we're interacting with Algolia API or Swagger API
  if (scrollCheck(location)) {
    return false
  }

  window.scrollTo(...(currentPosition || [0, 0]))
}

export const onRouteUpdate = () => {
  // Timeout to prevent lag from `react-helmet` from messing with what we send up to Segment
  // https://github.com/gatsbyjs/gatsby/blob/master/packages/gatsby-plugin-google-analytics/src/gatsby-browser.js#L13
  // Matches what's specified for `gatsby-plugin-google-gtag` pageTransitionDelay
  setTimeout(() => {
    // Segment
    // Capture page event
    if (window.analytics) {
      window.analytics.page(document.title, {
        node_type: document.querySelector("meta[name='node-type']")
          ? document
              .querySelector("meta[name='node-type']")
              .getAttribute('content')
          : 'page',
      })

      // Passed as a track function as Segment doesn't support pulling in page properties as custom dimensions in GA
      if (document.querySelector('time[itemProp="datePublished"]')) {
        track('Date published', {
          datePublished: document
            .querySelector('time[itemProp="datePublished"]')
            .getAttribute('dateTime'),
        })
      }
    } else {
      // eslint-disable-next-line no-console
      console.table({
        title: document.title,
        node_type: document.querySelector("meta[name='node-type']")
          ? document
              .querySelector("meta[name='node-type']")
              .getAttribute('content')
          : 'page',
        datePublished: document.querySelector('time[itemProp="datePublished"]')
          ? document
              .querySelector('time[itemProp="datePublished"]')
              .getAttribute('dateTime')
          : null,
      })
    }
  }, 100)
}

export const wrapRootElement = Wrap
